import React, { Component } from 'react';

import '../../../styles/colorCheckbox.scss';

class ColorCheckbox extends Component {
  // provide a synthetic wrapper for input checkbox that will act as a legend.
  render() {
    return (
      <div className={'color-checkbox ' + this.props.className} onClick={this.props.handleChange}>
        <input
          type="checkbox"
          value={this.props.value}
          checked={this.props.value}
          className={'color-checkbox ' + this.props.className}
          onChange={() => undefined}
        />
        <label
          className="label-inline"
          className={'color-checkbox ' + this.props.className}
          htmlFor={this.props.title}
        >
          {this.props.title}
        </label>
      </div>
    );
  }
}

export default ColorCheckbox;
